import { RefObject, useCallback } from 'react'

import { useVideoAnalytics } from '@/components/VideoPlayer/hooks/useAnalytics'
import {
  eventObject,
  eventAction,
  videoPlayerNames,
  analyticsVideoTypes,
} from '@/constants/analytics'
import useStore from '@/store/useStore'
import { PartnerLinkType } from '@/types/servicesTypes/configTypes'
import {
  getAnalyticsUserData,
  getEpgObject,
  sendAnalyticsEvent,
} from '@/utils/analyticsUtils'

import { YouTubePlayerType } from './YouTubePlayer'

export function useYouTubeAnalytics(
  id: string,
  videoUrl: string,
  isVideoPlaying: boolean,
  isVideoStarted: boolean,
  videoElementRef: RefObject<YouTubePlayerType>,
  name?: string,
  partnerIds?: PartnerLinkType[],
) {
  const currentEvent = useStore((state) => state.common.currentEvent)
  const isStream = !!currentEvent?.live

  const sendVideoStartedAnalyticsEvent = useCallback(() => {
    const epg = currentEvent ? getEpgObject(currentEvent) : undefined
    const user = getAnalyticsUserData()

    sendAnalyticsEvent({
      object: eventObject.VIDEO,
      action: eventAction.START,
      video: {
        id: id,
        name: name || id,
        playerName: videoPlayerNames.YOUTUBE,
        autoPlay: false,
        type: isStream ? analyticsVideoTypes.STREAM : analyticsVideoTypes.VOD,
        length: isStream
          ? 0
          : Math.round(videoElementRef?.current?.playerInfo?.duration || 0),
        link: videoUrl,
        epg: epg,
        partnerIds,
      },
      user,
    })
  }, [id])

  useVideoAnalytics({
    videoId: id,
    isVideoStarted,
    isVideoPlaying,
    videoElementRef,
    videoData: { id: id, url: videoUrl },
    isStream,
    sendVideoStartedAnalyticsEvent,
    isYouTubePlayer: true,
  })
}
